import { AUTH_CACHE_KEY } from '@aibees/shared/auth/constants';
import { API_URL } from '@aibees/shared/constants';
import { useWorkspace } from '@aibees/shared/workspace';
import { TAX_ID } from '@aibees/shared/workspace/constants/endpoints';
import { useCallback } from 'react';
export const useTaxIdHandlers = (
  taxIds: any[],
  setRows: any,
  notify: any,
  onRefetch?: () => void,
  onDeleteTaxId?: (taxIdDbId: string) => Promise<void>,
  onChange?: () => void,
  onClearError?: () => void
) => {
  const workspaceId = useWorkspace()?.id ?? '';

  const createRemoveHandler = useCallback(
    (rowIndex: number) => (e?: any) => {
      const isExisting = taxIds[rowIndex]?.existing;
      const taxIdDbId = taxIds[rowIndex]?.id;

      if (!isExisting) {
        setRows((prev: number[]) => prev.filter((i) => i !== rowIndex));
        onChange?.();
        onClearError?.();
        return;
      }

      if (!taxIdDbId) return;

      const deleteTaxId = async () => {
        try {
          const url = `${API_URL}${TAX_ID.replace(
            ':customerId',
            workspaceId
          )}/${taxIdDbId}`;

          const authData = localStorage.getItem(AUTH_CACHE_KEY);
          const token = authData ? JSON.parse(authData)?.access_token : null;

          const response = await fetch(url, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token ? `Bearer ${token}` : '',
            },
          });

          if (!response.ok) {
            throw new Error('Failed to delete tax ID');
          }

          notify.success('Tax ID deleted successfully');
          setRows((prev: number[]) => prev.filter((i) => i !== rowIndex));
          onRefetch?.();
          onClearError?.();
          if (e?.toggle) e.toggle();
        } catch (error) {
          notify.error('Failed to delete Tax ID');
        }
      };

      deleteTaxId();
    },
    [taxIds, setRows, notify, onRefetch, workspaceId, onChange, onClearError]
  );

  const getIsExisting = useCallback(
    (rowIndex: number) => {
      return taxIds[rowIndex]?.existing;
    },
    [taxIds]
  );

  return { createRemoveHandler, getIsExisting };
};
